import { normalizeGsm } from './normalizeGsm';

export const buildEmployeeUpdateRequestDto = ({ record, values, isAddressUpdate }) => ({
  ...values,
  personalCode: record?.personalCode,
  cardNumber: record?.cardNumber,
  gsm: normalizeGsm(values?.gsm),
  isAddressUpdate,
});
